import { useState, useEffect } from 'react';
import { useAuth } from '../Auth';
import keyGen from '../keygen';
import { useLocalStorage } from './useLocalStorage';
import { trackerDefaults } from '../QRFunctions/defaultSurveyTrackerValues';
import { getQrDataFieldType } from '../../lib/getQrDataFieldType';
import API from '../../API';

export const useQR = (reference, id) => {
    const { optionsDispatch, dataDispatch, liquidQRs } = useAuth();
    const [ newId, setNewId ] = useState('');
    const [ value ] = useLocalStorage('qr_type');
    
    useEffect(() => {
        let isMounted = true;
        const { getQR, getProduct } = API;
        const handleGetQR = async () => {
            try {
                if (liquidQRs.length > 0) {
                    const qrReturn = liquidQRs.find(qr => qr?.id === id);
                    if (qrReturn) {
                        optionsDispatch({type: 'edit', options: qrReturn.data.qr_style});
                        dataDispatch({type: 'edit', data: qrReturn});
                        return;
                    }
                }

                const res = await getQR(id);
                if (isMounted) {
                    if (id.includes('-') && !res.created_at) {
                        optionsDispatch({
                            type: 'edit',
                            options: {
                                ...res.qr_style,
                                type: 'svg',
                                shape: 'square',
                                backgroundOptions: {
                                    ...res.qr_style.backgroundOptions,
                                    color: '#ffffff'
                                }
                            }
                        })
                        dataDispatch({type: 'edit', data: { id: id, data: {...res, qr_type: '', nickname: '', redirect_url: ''}}})
                        if (res.product_id) {
                            const product = await getProduct(res.product_id);
                            dataDispatch({type: "qr_type", data: product.default_qr_type});
                            const fieldType = getQrDataFieldType(product.default_qr_type);
                            if (fieldType === 'tracker' || fieldType === 'survey') {
                                const dispatchData = {
                                    description: '',
                                    fields: trackerDefaults[product.default_qr_type]
                                };
                                
                                if (fieldType === 'survey') {
                                    dispatchData.post_survey_options = {
                                        message: '',
                                        title: '',
                                        url: ''
                                    };
                                }
                                
                                dataDispatch({
                                    type: fieldType,
                                    data: dispatchData
                                });
                            }
                        }
                    } else if (res) {
                        optionsDispatch({type: 'edit', options: res.qr_style})
                        dataDispatch({type: 'edit', data: { id: id, data: res}})
                    };
                };
            } catch (err) {
                if (isMounted) {
                    console.error(err);
                }
            };
        };

        const handleKeyGen = async () => {
            try {
                const generatedId = await keyGen();
                if (isMounted) {
                    if (generatedId) {
                        setNewId(generatedId);
                        optionsDispatch({type: 'liquid', options: { randKey: generatedId}});
                        dataDispatch({type: 'new', data: generatedId});
                        if (value) {
                            dataDispatch({type: 'qr_type', data: value})
                        }
                    }
                }
            } catch (err) {
                if (isMounted) {
                    console.error(err);
                }
            };
        };
        
        if ((reference === 'edit' || reference === 'details' || reference === 'linked' || reference === 'design') && id) {
            handleGetQR();
        } else if (reference === 'new' && !newId) {
            handleKeyGen();
        };
        
        return () => { isMounted = false };
    },[id, reference, newId, optionsDispatch, dataDispatch, value, liquidQRs]);
};
